/* ==========================================================================
   Hero — encaje del escenario y revelado de los tatuajes con el cursor.
   El hero NO es un slider: el Figma solo define una composición (ver
   docs/figma-extract/hero-alt.md). El carrusel de las tarjetas laterales se
   fue con el rediseño del 8-oct (nodo 1384:6064): los laterales son fijos.
   ========================================================================== */

(function () {
  'use strict';

  /**
   * Encaja la composición de 1920×1080 del Figma en una sola pantalla.
   * CSS no puede dividir dos longitudes para sacar un número, así que el factor
   * se calcula aquí y se expone como --hero-scale.
   * Se usa el MÍNIMO de los dos ratios: así se ve el hero completo sin scroll.
   * El fondo va fuera del escenario y cubre el viewport, así que no quedan bandas.
   */
  function fitHero() {
    var heroes = document.querySelectorAll('[data-hero="root"]');
    for (var i = 0; i < heroes.length; i++) {
      var hero = heroes[i];
      if (window.innerWidth <= 1099) {
        hero.style.removeProperty('--hero-scale');
        continue;
      }
      var box = hero.getBoundingClientRect();
      var scale = Math.min(box.width / 1920, box.height / 1080);
      hero.style.setProperty('--hero-scale', Math.round(scale * 10000) / 10000);
    }
  }

  function init() {
    fitHero();
    initReveal();
  }

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(fitHero, 120);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* ======================================================================
     Revelado de los tatuajes con el cursor (Robert, 7-ago).

     La foto de la modelo son dos capas alineadas al píxel: debajo la de
     tatuajes a color y encima la de tatuajes en gris, recortada por una
     máscara redonda que sigue al puntero. Aquí solo se mueve el agujero.

     La máscara y el `display: block` viven en el CSS bajo
     `(min-width: 1024px) and (hover: hover) and (pointer: fine)`, así que en
     móvil este código no tiene nada sobre lo que actuar: la capa de grises ni
     siquiera se pinta.

     ⚠ Las variables van en la IMAGEN, no en `.gyaa-hero__model`: ese
     contenedor lo anima GSAP y su timeline acaba con `clearProps: 'all'`, que
     borraría los estilos inline —incluidas las custom properties— y dejaría
     el agujero descolocado.
     ====================================================================== */
  function initReveal() {
    var capas = document.querySelectorAll('[data-hero-reveal]');
    for (var i = 0; i < capas.length; i++) {
      (function (capa) {
        var zona = capa.parentNode;
        if (!zona || zona.dataset.revealBound === 'true') return;
        zona.dataset.revealBound = 'true';

        var pendiente = false;
        var px = 0;
        var py = 0;

        function pintar() {
          pendiente = false;
          capa.style.setProperty('--mx', px + 'px');
          capa.style.setProperty('--my', py + 'px');
        }

        zona.addEventListener('pointermove', function (event) {
          /* Solo ratón/lápiz: con el dedo el agujero se quedaría clavado
             donde tocaste hasta el siguiente toque. */
          if (event.pointerType === 'touch') return;
          var caja = capa.getBoundingClientRect();
          /* ⚠ El stage del hero va con `transform: scale()`, así que la caja
             que devuelve getBoundingClientRect está en píxeles VISUALES y la
             máscara trabaja en los de layout (921 de ancho). Sin dividir por
             la escala el agujero sale desplazado hacia arriba y a la
             izquierda, y el fallo parece un desalineado de las fotos.
             `offsetWidth` no le afecta el transform: de ahí sale la escala. */
          var escala = capa.offsetWidth ? caja.width / capa.offsetWidth : 1;
          if (!escala) escala = 1;
          px = (event.clientX - caja.left) / escala;
          py = (event.clientY - caja.top) / escala;
          /* Un frame por movimiento: `pointermove` dispara mucho más rápido
             que la pantalla y escribir la variable en cada evento provoca
             recálculos de máscara de más. */
          if (!pendiente) {
            pendiente = true;
            requestAnimationFrame(pintar);
          }
        });

        zona.addEventListener('pointerleave', function () {
          /* Se aparca el agujero fuera del lienzo en vez de quitar la máscara:
             así la foto vuelve a verse entera en gris sin ningún salto. */
          px = -9999;
          py = -9999;
          pintar();
        });
      })(capas[i]);
    }
  }

  // El editor de temas re-renderiza secciones: re-inicializar.
  document.addEventListener('shopify:section:load', init);
})();
